<template>
  <div class="login">
    <div class="login_box">
    <!-- logo -->
    <div class="p1">
      <img src="./../../assets/img/logo.png" alt />
    </div>
    <!-- 微信登录 -->
    <template v-if="wx_qr">
      <div id="login_container"></div>
      <div class="register">
        <div @click="hangleChangeType">账号登录</div>
      </div>
    </template>
    <!-- 账密手机号登录 -->
    <template v-if="!wx_qr">
      <div class="p2">
        <div class="p2_tabs">
          <md-tab-bar
            ref="mdTabBar"
            v-model="active"
            :ink-length="80"
            :items="[{name:'1',label:'验证码登录'},{name:'2',label:'账号密码登录'}]"
          />
        </div>      
        <div class="p2_cons">
          <div class="p2_con" v-show="active==1">
            <div class="login_con mc_login">
              <div class="p_input p_input_mc">
                <div class="p_input_item pi_phone">
                  <img src="./../../assets/img/login/login_username.png" alt class="icon" />
                  <input type="number" placeholder="请输入手机号" v-model="subData_code.mobile" />
                  <md-icon
                    name="close"
                    v-show="subData_code.mobile"
                    @click="subData_code.mobile=''"
                    size="sm"
                  ></md-icon>
                </div>
                <div class="p_input_item pi_code">
                  <img src="./../../assets/img/login/login_password.png" alt class="icon" />
                  <input type="number" placeholder="请输入验证码" v-model="subData_code.code" />
                  <button class="sendCode" :disabled="isSend" @click="sendCode">{{sendTxt}}</button>
                </div>
              </div>
              <div class="p_button">
                <div @click="login_code">登 录</div>
              </div>
            </div>
          </div>
          <div class="p2_con" v-show="active==2">
            <div class="login_con up_login">
              <div class="p_input p_input_up">
                <div class="pi_phone p_input_item">
                  <img src="./../../assets/img/login/login_username.png" alt class="icon" />
                  <input type="text" placeholder="请输入手机号" v-model="subData.username" />
                  <md-icon
                    name="close"
                    v-show="subData.username"
                    @click="subData.username=''"
                    size="sm"
                  ></md-icon>
                </div>
                <div class="pi_password p_input_item">
                  <img src="./../../assets/img/login/login_password.png" alt class="icon" />
                  <input type="password" placeholder="请输入密码" v-model="subData.password" />
                </div>
              </div>
              <div class="p_check">
                <div class="p_forget">
                  <div class="forget" @click="toForget">忘记密码?</div>
                </div>
                <div>
                  <md-agree
                    v-model="checked"
                  >
                    <span @click.stop="checked = !checked">
                      记住密码
                    </span>
                  </md-agree>
                </div>
              </div>
              <div class="p_button">
                <div @click="login">登 录</div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="register">
        <div @click="hangleChangeType">扫码登录</div>
      </div>
    </template>
    </div>
  </div>
</template>

<script>
import { isEmpty, isMobile, isPassword0, isCode4 } from "@/utils/validate";
import { login, sendCode, codeLogin ,wxLogin} from "@/api/login";
import { setToken } from "@/utils/auth";
import Cookies from "@/utils/Cookies";
var t;
export default {
  name: "login",
  data() {
    return {
      checked: true,
      active: '1',
      subData: {
        username: "",
        password: "",
        group: "androidPad"
      },
      subData_code: {
        mobile: "",
        code: "",
        group: "androidPad"
      },

      isSend: false,
      sendTxt: "发送验证码",

      wx_qr:false 
    };
  },
  created() {
    var account = Cookies.get("account");
    if (account) {
      this.subData = {
        username: JSON.parse(account).username,
        password: JSON.parse(account).password,
        group: "androidPad"
      };
      this.checked = true;
    }
  },
  mounted() {
    setTimeout(()=>{
      if( this.$route.query.wxLogin ){
        this.hangleChangeType()
        this.sendWxLogin(this.$route.query.code)
      }else{
        this.$nextTick(()=>{
          this.$refs.mdTabBar.reflow()
        })
      }
    },10)
  },
  methods: {
    //   登录
    login() {
      if (!isMobile(this.subData.username)) {
        this.$toast.failed("请输入正确的手机号！");
      } else if (!isPassword0(this.subData.password)) {
        this.$toast.failed("请输入正确的密码！");
      } else {
        const toast = this.$toast.loading("登录中...");
        login(this.subData).then(res => {
          if (res.code == 200) {
            toast.hide()
            if (this.checked) {
              Cookies.set("account", JSON.stringify(this.subData));
            }
            this.$toast.succeed("登录成功");
            setToken(res.data.access_token);
            Cookies.set("userInfo", JSON.stringify(res.data.user));
            Cookies.set("shopInfo", JSON.stringify(res.data.shop));
            this.$router.push("/");
          }
        });
      }
    },
    login_code() {
      if (!isMobile(this.subData_code.mobile)) {
        this.$toast.failed("请输入正确的手机号！");
      } else if (!isCode4(this.subData_code.code)) {
        this.$toast.failed("请输入正确的验证码！");
      } else {
        const toast = this.$toast.loading("登录中...");
        codeLogin(this.subData_code).then(res => {
          if (res.code == 200) {
            toast.hide();
            this.$toast.succeed("登录成功");
            setToken(res.data.access_token);
            Cookies.set("userInfo", JSON.stringify(res.data.user));
            Cookies.set("shopInfo", JSON.stringify(res.data.shop));
            this.$router.push("/");
          }
        });
      }
    },
    // 去忘记密码
    toForget() {
      this.$router.push("/forget");
    },
    // 去注册页面
    toUserRegister() {
      this.$router.push("/userRegister");
    },

    // 发送验证码
    sendCode() {
      if (isMobile(this.subData_code.mobile)) {
        this.isSend = true;
        this.sendTxt = "发送中";
        sendCode({ mobile: this.subData_code.mobile, usage: "login" })
          .then(res => {
            if (res.code == 200) {
              this.$toast.succeed("验证码发送成功，请注意查收");
              var time = 60;
              var that = this;
              t = setInterval(function() {
                if (time > 0) {
                  that.isSend = true;
                  that.sendTxt = time + "s";
                  time--;
                } else {
                  that.isSend = false;
                  that.sendTxt = "发送验证码";
                  clearInterval(t);
                }
              }, 1000);
            }
          })
          .catch(res => {
            this.isSend = false;
            this.sendTxt = "发送验证码";
          });
      } else {
        this.$toast.failed("请输入正确的手机号！");
      }
    },
    // 切换支付方式
    hangleChangeType(){
      this.wx_qr = !this.wx_qr
      if(document.getElementsByTagName("iframe").length>0){
        document.getElementsByTagName("iframe")[0].remove();
      }
      this.$nextTick(()=>{
        if(!this.wx_qr){
          this.$refs.mdTabBar.reflow()
        }else{
          var subData = {
            self_redirect:false,
            id:"login_container", 
            appid: "wx5c9c7c1a5bec316f", 
            scope: "snsapi_login", 
            redirect_uri:encodeURI(window.location.origin),
            state: "login",
            style: "black",
            href: window.location.origin +'./css/wx.css'
            // href:"https://192.168.4.106:8080/css/wx.css"
            
          }
          var obj = new WxLogin(subData);
        }
      })
    },
    // 发送请求
    sendWxLogin(code){
      const toast = this.$toast.loading("登录中...");
      wxLogin({code,group:'androidPad'}).then(res=>{
        if (res.code == 200) {
          toast.hide()
          this.$toast.succeed("登录成功");
          setToken(res.data.access_token);
          Cookies.set("userInfo", JSON.stringify(res.data.user));
          Cookies.set("shopInfo", JSON.stringify(res.data.shop));
          this.$router.push("/");
        }
      }).catch(res=>{
        delete this.$route.query.code
        // this.$router.replace({wxLogin:1})
      })
    },
  }
};
</script>

<style lang="less" scoped>
.login {
  width: 100%;
  height: 100%;
  box-sizing: border-box;
  background: url(./../../assets/img/login/bg.jpg) no-repeat center center;
  background-size: 100% 100%;
  position: relative;
  font-size: 0.20rem;
  display: flex;
  align-items: center;
  justify-content: center;
  .login_box{
    width: 6.1rem;
    margin: 0 auto;
    background-color: rgba(255,255,255,0.4);
    border-radius: 0.2rem;
    box-shadow:0 0.4rem 0.2rem 0 rgba(156,123,62,0.28);
    overflow: hidden;
  }
  #login_container{
    margin: 0 auto;
    text-align: center;
    display: flex;
    justify-content: center;
    iframe{
      width: 4rem;
    }
  }
  .p1 {
    padding-bottom: 0.3rem;
    padding-top: 0.4rem;
    width: 100%;
    text-align: center;
    display: flex;
    flex-wrap: wrap;
    justify-content: center;
    span {
      width: 100%;
      font-size: 0.42rem;
      font-weight: 600;
      color: rgba(49, 177, 88, 1);
      text-shadow: 0 0.05rem 0.08rem rgba(49, 177, 88, 0.33);
      letter-spacing: 0.1rem;
    }
    img {
      width: 1.94rem;
      height: 0.79rem;
    }
  }
  .p2 {
    width: 6.1rem;
    // width: 4.34rem;
    margin: 0 auto;
    .p2_tabs {
      width: 4.34rem;
      margin: 0 auto;
      display: flex;
      align-items: center;
      justify-content: space-around;
      .p2_tab {
        color: #9a9a9a;
        transition: 0.3s all;
        padding-bottom: 0.1rem;
        font-size: 0.24rem;
        border-bottom: 0.03rem solid transparent;
        &[active] {
          border-bottom: 0.03rem solid #32b258;
          color: #32b258;
        }
      }
    }
    .p2_cons{
      width: 4.34rem;
      margin: 0 auto;
      .p2_con {
        width: 4.34rem;
        margin: 0 auto;
        position: relative;
        font-size: 0.24rem;
        .login_con {
          .p_input {
            position: relative;
            .p_input_item {
              margin-top: 0.4rem;
              line-height: 0.62rem;
              height: 0.62rem;
              border-radius: 0.31rem;
              display: flex;
              justify-content: space-between;
              align-items: center;
              box-shadow: 0 0.05rem 0.06rem 0 rgba(49, 177, 88, 0.15);
              background-color: #fff;
              background-color: #E6D8C2;
              overflow: hidden;
              padding-right: 0.15rem;
              & > .icon {
                width: 0.2rem;
                height: 0.24rem;
                box-sizing: content-box;
                display: block;
                padding-left: 0.4rem;
                padding-right: 0.3rem;
              }
              input {
                width: 100%;
                outline: none;
                border: none;
                font-size: 0.24rem;
                color: #404040;
                background-color: transparent;
                &::placeholder {
                  color: #999;
                }
              }
            }
            .pi_code {
              input {
                width: 2.09rem;
              }
              .sendCode {
                width: 1.2rem;
                height: 0.4rem;
                border-radius: 0.2rem;
                border: 0.02rem solid #31b158;
                background-color: #32B258;
                font-size: 0.20rem;
                box-sizing: border-box;
                text-align: center;
                line-height: 0.36rem;
                color: #fff;
                &[disabled] {
                  border: 0.02rem solid #999;
                  background-color: #999;
                  color: #fff;
                }
              }
            }
          }

          .p_check {
            padding: 0 0.2rem;
            font-size: 0.20rem;
            margin-top: 0.2rem;
            text-align: right;
            color: #999999;
            display: flex;
            align-items: center;
            justify-content: space-between;
            & > div {
              display: inline-block;
            }
            .van-checkbox__label > span {
              color: #999999 !important;
            }
          }
          .p_button {
            margin-top: 0.4rem;
            div {
              width: 4.34rem;
              box-sizing: border-box;
              height: 0.62rem;
              border-radius: 0.31rem;
              font-size: 0.24rem;
              line-height: 0.62rem;
              text-align: center;
              color: #999;
              font-weight: 500;
              border: 0.02rem solid #ccc;
              &:nth-child(1) {
                background: linear-gradient(-90deg, #25a94d, #3fbe66);
                box-shadow: 0 0.05rem 0.06rem 0 rgba(49, 177, 88, 0.15);
                border: none;
                color: #fff;
              }
            }
          }
          .p_forget {
            // margin-top: 0.49rem;
            text-align: center;
            .forget {
              color: #999999;
              font-size: 0.20rem;
            }
          }
        }
        .mc_login {
        }
      }
    }
  }
  .register {
    margin-top: 0.2rem;
    width: 100%;
    text-align: center;
    font-size: 0.20rem;
    color: #999;
    margin-bottom: 0.3rem;
    // display: flex;
    // align-items: center;
    // justify-content: space-between;
  }
}
</style>

<style lang="less">
.login{
  .md-agree-icon{
    margin-right: 0;
  }
  .md-tab-bar{
    background-color: transparent;
    color: #666;
  }
}
</style>